import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import GridContainer from '@/components/Grid/GridContainer';
import GridItem from '@/components/Grid/GridItem';
import CustomInput from '@/components/CustomInput/CustomInput';
import Button from '@/components/CustomButtons/Button';

const TangoTab = ({ organization, updateOrganization }) => {
  const { t } = useTranslation();
  const [giftcards, setGiftcards] = useState(organization.tangoGiftcardsUids);
  const [donations, setDonations] = useState(organization.tangoDonationsUids);
  const [venmo, setVenmo] = useState(organization.venmoUids);
  const [paypal, setPaypal] = useState(organization.paypalUids);
  const handleGiftcards = (e) => setGiftcards(e.target.value);
  const handleDonations = (e) => setDonations(e.target.value);
  const handleVenmo = (e) => setVenmo(e.target.value);
  const handlePaypal = (e) => setPaypal(e.target.value);
  const handleUpdate = async () => {
    const formData = new FormData();
    formData.append('tangoGiftcardsUids', giftcards);
    formData.append('tangoDonationsUids', donations);
    formData.append('venmoUids', venmo);
    formData.append('paypalUids', paypal);
    await updateOrganization(formData);
  };
  return (
    <>
      <GridContainer style={{ paddingTop: '30px' }}>
        <GridItem xs={12} sm={12} md={6}>
          <CustomInput
            labelText={t('organizations.update.giftcardsLabel')}
            id='giftcards'
            name='giftcards'
            onChange={handleGiftcards}
            value={giftcards}
            type='text'
            formControlProps={{
              fullWidth: true,
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <CustomInput
            labelText={t('organizations.update.donationsLabel')}
            id='donations'
            name='donations'
            onChange={handleDonations}
            value={donations}
            type='text'
            formControlProps={{
              fullWidth: true,
            }}
          />
        </GridItem>

        <GridItem xs={12} sm={12} md={6}>
          <CustomInput
            labelText={t('organizations.update.venmoLabel')}
            id='venmo'
            name='venmo'
            onChange={handleVenmo}
            value={venmo}
            type='text'
            formControlProps={{
              fullWidth: true,
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <CustomInput
            labelText={t('organizations.update.paypalLabel')}
            id='paypal'
            name='paypal'
            onChange={handlePaypal}
            value={paypal}
            type='text'
            formControlProps={{
              fullWidth: true,
            }}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <Button color='primary' onClick={handleUpdate}>
            {t('common.buttons.update')}
          </Button>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}></GridItem>
      </GridContainer>
    </>
  );
};

export default TangoTab;
